import { render, staticRenderFns } from "./block-credentials-checker.vue?vue&type=template&id=1ea1b280&scoped=true&lang=pug&"
import script from "./block-credentials-checker.vue?vue&type=script&lang=js&"
export * from "./block-credentials-checker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea1b280",
  null
  
)

export default component.exports